<script lang="ts">
    import type { IconAnimated } from "@components/material/Icon.module"
    import { generateIcon } from "@components/material/Icon.module"
    import "./icon.css"

    let className = ""
    export { className as class }

    export let icon: IconAnimated
    export let toggled = false

    const vectorEffect = "non-scaling-stroke"
</script>

{#if icon == "animatedEdit"}
    <svg
        class={className}
        xmlns="http://www.w3.org/2000/svg"
        data-icon-name={icon}
        viewBox="0 0 32 32"
    >
        <g
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
            fill="none"
            stroke="currentColor"
        >
            <g
                class="js-nc-int-icon nc-int-edit-to-check js-nc-int-icon-loaded"
                class:nc-int-icon-state-b={toggled}
            >
                <path d="M11,24,3,27l3-8L23,2l5,5L11,24" stroke-linecap="butt" />
                <line x1="8" x2="28" y1="29" y2="29" stroke="currentColor" />
                <line x1="11" x2="4" y1="24" y2="17" />
            </g>
        </g>
    </svg>
{:else if icon == "eyeToggle"}
    <svg
        class={className}
        xmlns="http://www.w3.org/2000/svg"
        data-icon-name={icon}
        viewBox="0 0 32 32"
    >
        <title>eye-open-close</title>
        <g
            stroke-linecap="square"
            stroke-linejoin="miter"
            stroke-width="2"
            fill="none"
            stroke="currentColor"
        >
            <g
                class="js-nc-int-icon nc-int-eye-open-close js-nc-int-icon-loaded"
                class:nc-int-icon-state-b={toggled}
            >
                <circle cx="16" cy="16" r="5" stroke="none" fill="currentColor" />
                <path
                    d="M2,16s6,8,14,8,14-8,14-8"
                    data-cap="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M2,16S8,8,16,8s14,8,14,8"
                    data-cap="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <line
                    opacity="0"
                    x1="12.768"
                    x2="11.563"
                    y1="8.427"
                    y2="4.583"
                    stroke-linecap="butt"
                />
                <line
                    opacity="0"
                    x1="19.232"
                    x2="20.437"
                    y1="8.427"
                    y2="4.583"
                    stroke-linecap="butt"
                />
                <line
                    opacity="0"
                    x1="6.563"
                    x2="4.141"
                    y1="11.563"
                    y2="8.482"
                    stroke-linecap="butt"
                />
                <line
                    opacity="0"
                    x1="25.437"
                    x2="27.859"
                    y1="11.563"
                    y2="8.482"
                    stroke-linecap="butt"
                />
            </g>
        </g>
    </svg>
{:else if icon == "muteToggle"}
    <svg
        class={className}
        xmlns="http://www.w3.org/2000/svg"
        data-icon-name={icon}
        viewBox="0 0 32 32"
    >
        <g
            stroke-linecap="square"
            stroke-linejoin="miter"
            stroke-width="2"
            fill="none"
            stroke="currentColor"
            stroke-miterlimit="10"
        >
            <g class="js-nc-int-icon nc-sound-on-off" class:nc-int-icon-state-b={toggled}>
                <polyline points="19 19 19 4 11 10 10 10" stroke-linecap="butt" />
                <path d="M5.9,10H5a3,3,0,0,0-3,3v6a3,3,0,0,0,3,3h6l8,6V23.083" />
                <path d="M27,9.755a8,8,0,0,1,0,12.49" stroke="currentColor" />
                <path d="M24,13.764a3,3,0,0,1,0,4.472" stroke="currentColor" />
                <line x1="10" x2="5.896" y1="10" y2="10" stroke-linecap="butt" />
                <line x1="19" x2="19" y1="23.083" y2="19" stroke-linecap="butt" />
                <line
                    x1="3"
                    x2="29"
                    y1="3"
                    y2="29"
                    stroke-dasharray="36.77 36.77"
                    stroke-dashoffset="36.77"
                    stroke="currentColor"
                />
            </g>
        </g>
    </svg>
{:else if icon == "checkbox"}
    <svg
        class={className}
        xmlns="http://www.w3.org/2000/svg"
        data-icon-name={icon}
        viewBox="0 0 16 16"
    >
        <title>input-checkbox</title>
        <g>
            <g class="js-nc-int-icon nc-int-input-checkbox" class:nc-int-icon-state-b={toggled}>
                <rect vector-effect={vectorEffect} fill="#c8c8c8" height="16" rx="4" width="16" />
                <polyline
                    vector-effect={vectorEffect}
                    fill="none"
                    points="3 8.5 6 11.5 13 4.5"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                />
            </g>
        </g>
    </svg>
{:else if icon == "maxmin"}
    <svg
        class={className}
        xmlns="http://www.w3.org/2000/svg"
        data-icon-name={icon}
        viewBox="0 0 32 32"
    >
        <title>max-to-min</title>
        <g
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            fill="none"
            stroke="currentColor"
        >
            <g class="js-nc-int-icon nc-int-max-to-min" class:nc-int-icon-state-b={toggled}>
                <line vector-effect={vectorEffect} x1="3" x2="11" y1="3" y2="3" />
                <line vector-effect={vectorEffect} x1="3" x2="3" y1="11" y2="3" />
                <line
                    vector-effect={vectorEffect}
                    x1="29"
                    x2="29"
                    y1="3"
                    y2="11"
                    stroke="currentColor"
                />
                <line
                    vector-effect={vectorEffect}
                    x1="21"
                    x2="29"
                    y1="3"
                    y2="3"
                    stroke="currentColor"
                />
                <line
                    vector-effect={vectorEffect}
                    x1="3"
                    x2="11"
                    y1="29"
                    y2="29"
                    stroke="currentColor"
                />
                <line
                    vector-effect={vectorEffect}
                    x1="3"
                    x2="3"
                    y1="21"
                    y2="29"
                    stroke="currentColor"
                />
                <line vector-effect={vectorEffect} x1="29" x2="29" y1="29" y2="21" />
                <line vector-effect={vectorEffect} x1="21" x2="29" y1="29" y2="29" />
            </g>
        </g>
    </svg>
{:else if icon == "copied"}
    <svg
        class={className}
        xmlns="http://www.w3.org/2000/svg"
        data-icon-name={icon}
        viewBox="0 0 32 32"
    >
        <title>copy-to-clipboard</title>
        <g
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            fill="none"
            stroke="currentColor"
        >
            <g class="js-nc-int-icon nc-int-copy-to-clipboard" class:nc-int-icon-state-b={toggled}>
                <path
                    vector-effect={vectorEffect}
                    d="M25,4h1a2,2,0,0,1,2,2V28a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H7"
                />
                <rect
                    vector-effect={vectorEffect}
                    height="4"
                    width="10"
                    x="11"
                    y="2"
                    stroke="currentColor"
                />
                <polyline
                    vector-effect={vectorEffect}
                    points="10 19 13 22 22 13"
                    stroke="currentColor"
                /></g
            >
        </g>
    </svg>
{:else if icon == "loading"}
    <svg
        xmlns="http://www.w3.org/2000/svg"
        class={className}
        data-icon-name={icon}
        viewBox="0 0 48 48"
        ><title>loading</title><g
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
            transform="translate(0.5 0.5)"
            fill="none"
            stroke="#212121"
            ><g class="nc-loop-dots-4-48-icon-o"
                ><circle cx="9" cy="24" r="5" /><circle
                    cx="24"
                    cy="24"
                    r="5"
                    stroke="#212121"
                /><circle cx="39" cy="24" r="5" /></g
            ><style>
                .nc-loop-dots-4-48-icon-o {
                    --animation-duration: 0.8s;
                }
                .nc-loop-dots-4-48-icon-o * {
                    opacity: 0.4;
                    transform: scale(0.75);
                    animation: nc-loop-dots-4-anim var(--animation-duration) infinite;
                }
                .nc-loop-dots-4-48-icon-o :nth-child(1) {
                    transform-origin: 9px 24px;
                    animation-delay: -0.3s;
                    animation-delay: calc(var(--animation-duration) / -2.666);
                }
                .nc-loop-dots-4-48-icon-o :nth-child(2) {
                    transform-origin: 24px 24px;
                    animation-delay: -0.15s;
                    animation-delay: calc(var(--animation-duration) / -5.333);
                }
                .nc-loop-dots-4-48-icon-o :nth-child(3) {
                    transform-origin: 39px 24px;
                }
                @keyframes nc-loop-dots-4-anim {
                    0%,
                    100% {
                        opacity: 0.4;
                        transform: scale(0.75);
                    }
                    50% {
                        opacity: 1;
                        transform: scale(1);
                    }
                }
            </style></g
        ></svg
    >
{:else}
    {@html generateIcon(icon, className, vectorEffect)}
{/if}
